import { render, staticRenderFns } from "./CountryEdit.vue?vue&type=template&id=0953f85e&scoped=true&"
import script from "./CountryEdit.vue?vue&type=script&lang=js&"
export * from "./CountryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953f85e",
  null
  
)

export default component.exports